import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import CreditDetails from 'ui/run/RunShow/components/CreditDetails';

const propTypes = {};
const defaultProps = {};

const RunCreditDetails = () => {
  const runType = useSelector((state) => state.runType);
  const startDate = useSelector((state) => state.startDate);
  const endDate = useSelector((state) => state.endDate);
  const quantConfig = useSelector((state) => state.quantConfig);
  const granularity = useSelector((state) => state.granularity);

  return (
    <div className="float-left mt-4">
      <div className="mb-5">
        <CreditDetails
          runType={runType}
          granularity={granularity}
          isConsumed={false}
          startDate={startDate}
          endDate={endDate}
          instrumentGroups={_.get(quantConfig, 'instrumentGroups', [])}
          cases={_.get(quantConfig, 'cases', [])}
        />
      </div>
    </div>
  );
};

RunCreditDetails.propTypes = propTypes;
RunCreditDetails.defaultProps = defaultProps;

export default RunCreditDetails;
